import { render, staticRenderFns } from "./FlavorCard.vue?vue&type=template&id=8366dd6c&"
import script from "./FlavorCard.vue?vue&type=script&lang=js&"
export * from "./FlavorCard.vue?vue&type=script&lang=js&"
import style0 from "./FlavorCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports